
define('text!templates/modules/member/member/member-lists-controller.html',[],function () { return '<div class="empty-list-alert"></div>\n<div id="member-list-active"></div>\n<div id="member-list-pending"></div>\n<div id="member-list-inactive"></div>\n';});

